import { render, staticRenderFns } from "./ApexHeatMapRecognitions.vue?vue&type=template&id=268329d6&"
import script from "./ApexHeatMapRecognitions.vue?vue&type=script&lang=js&"
export * from "./ApexHeatMapRecognitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports